import { TiVoTargetsTable } from "components/elements";
import { Column, Row, Section, Subsection } from "components/layout";
import {
  PARTNER_PICKS_REPORTINGS,
  PARTNER_PICKS_TYPES,
  ReleaseStage,
  TiVoPresentation,
} from "hooks/tivoApps";
import { NO_VALUE_PLACEHOLDER } from "src/constants";

import { TEXTS } from "../constants";
import { PresentationConfigs } from "./PresentationConfigs";
import styles from "./PresentationSection.scss";

export function PresentationConfigSummary({
  presentation,
  selectedStage,
}: {
  presentation: TiVoPresentation;
  selectedStage: ReleaseStage;
}) {
  return (
    <>
      <Section
        header={`${TEXTS.PRESENTATION.CONFIGS_SECTION_HEADER} for ${selectedStage}`}
        className={styles.presentation}
      >
        <Row className={styles.summary}>
          <Column>
            <Subsection header={TEXTS.PRESENTATION.LABEL_SUBS_HEADER}>
              {presentation.label || NO_VALUE_PLACEHOLDER}
            </Subsection>
          </Column>
          <Column>
            <TiVoTargetsTable targets={presentation.targets} />
          </Column>
        </Row>
        <Row>
          <Column>
            <div className={styles.configs}>
              <PresentationConfigs configs={presentation.configs} />
            </div>
          </Column>
        </Row>
      </Section>
      <Section header={TEXTS.PRESENTATION.PARTNER_PICKS_SECTION_HEADER}>
        <Row>
          <Column>
            <Subsection header={TEXTS.PRESENTATION.ASPECT_RATIO_SUBS_HEADER}>
              {presentation?.partnerPicks?.aspectRatio || NO_VALUE_PLACEHOLDER}
            </Subsection>
            <Subsection header={TEXTS.PRESENTATION.TYPE_SUBS_HEADER}>
              {(presentation?.partnerPicks?.type &&
                PARTNER_PICKS_TYPES[presentation.partnerPicks.type]) ||
                NO_VALUE_PLACEHOLDER}
            </Subsection>
          </Column>
          <Column>
            <Subsection header={TEXTS.PRESENTATION.REPORTING_SUBS_HEADER}>
              {(presentation?.partnerPicks?.reporting &&
                PARTNER_PICKS_REPORTINGS[
                  presentation.partnerPicks.reporting
                ]) ||
                NO_VALUE_PLACEHOLDER}
            </Subsection>
          </Column>
        </Row>
      </Section>
    </>
  );
}
